import React, { useEffect } from "react";
import { Routes, Route, NavLink, useNavigate, useLocation } from "react-router-dom";
import { SEO } from "../../components/SEO";
import Features from "./Components/Features";
import PrivacyPolicy from "./Components/PrivacyPolicy";
import Support from "./Components/Support";

const StrongHabit: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (
      location.pathname === "/strong-habit" ||
      location.pathname === "/strong-habit/"
    ) {
      navigate("/strong-habit/features", { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <div
      style={{
        background: "#FAF9F7",
        minHeight: "100vh",
        padding: "40px 16px 64px",
        fontFamily: "'Outfit', sans-serif",
      }}
    >
      <SEO
        title="Refine - Minimal Habit Tracker"
        description="Privacy-first iOS habit tracker. Track your routines, protect your momentum, and see meaningful progress in a habit app designed for clarity instead of clutter."
        canonical="https://skystanoyevitch.com/strong-habit"
        type="article"
      />
      <div style={{ maxWidth: "860px", margin: "0 auto" }}>
        {/* Back Navigation */}
        <button
          onClick={() => navigate("/")}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "24px",
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "#2A3D4A",
            fontFamily: "'Outfit', sans-serif",
            fontSize: "14px",
            fontWeight: 400,
            letterSpacing: "0.02em",
            padding: 0,
            opacity: 0.72,
          }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M19 12H5M5 12l7 7M5 12l7-7" />
          </svg>
          Return
        </button>

        {/* Main Card Container */}
        <div
          style={{
            background: "#FFFFFF",
            boxShadow:
              "0 2px 4px rgba(42,61,74,0.06), 0 8px 48px rgba(42,61,74,0.09)",
            overflow: "hidden",
          }}
        >
          {/* Pill Tab Navigation */}
          <div
            style={{
              padding: "18px 32px",
              borderBottom: "1px solid #2A3D4A",
              background: "#FAF9F7",
            }}
          >
            <div
              style={{
                display: "inline-flex",
                gap: "4px",
                background: "#F0EDE8",
                padding: "4px",
                borderRadius: "999px",
              }}
            >
              <PillTab to="/strong-habit/features">Features</PillTab>
              <PillTab to="/strong-habit/support">Support</PillTab>
              <PillTab to="/strong-habit/legal">Privacy &amp; Terms</PillTab>
            </div>
          </div>

          {/* Tab Content */}
          <Routes>
            <Route path="/features" element={<Features />} />
            <Route path="/support" element={<Support />} />
            <Route path="/legal" element={<PrivacyPolicy />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

interface PillTabProps {
  to: string;
  children: React.ReactNode;
}

const PillTab: React.FC<PillTabProps> = ({ to, children }) => (
  <NavLink
    to={to}
    style={({ isActive }) => ({
      display: "inline-block",
      padding: "8px 20px",
      borderRadius: "999px",
      fontFamily: "'Outfit', sans-serif",
      fontSize: "13px",
      fontWeight: isActive ? 700 : 400,
      letterSpacing: "0.04em",
      textDecoration: "none",
      background: isActive ? "#2A3D4A" : "transparent",
      color: isActive ? "#FFFFFF" : "#2A3D4A",
      transition: "all 0.18s ease",
      whiteSpace: "nowrap",
    })}
  >
    {children}
  </NavLink>
);

export default StrongHabit;
